import React from "react";
import { Route, Redirect } from "react-router-dom";

const PublicRoute = (props) => {
  if(window.localStorage.getItem("user")){
    return <Redirect to='/home'/>;
  }else{
    return <Route {...props} />
  }
};  
export default PublicRoute;